import { initFadeSlider } from '@/lib/fadeSlider';
import { initParticles } from '@/lib/particles';

/**
 * Per-page setup, selected by the `data-init` attribute on the page's `main`
 * element. Keeps page-specific JavaScript out of every other page.
 */

function initHome(): void {
  const particleHost = document.getElementById('particles-js');

  if (particleHost) {
    initParticles(particleHost);
  }

  const bannerSlides = document.querySelector<HTMLElement>('.banner-slides');

  if (bannerSlides) {
    // The 2.2 code kept the wrapper hidden until slick fired its init event, to
    // avoid a flash of unstyled slides. The slider sets the first slide active
    // synchronously, so revealing straight afterwards is enough.
    initFadeSlider(bannerSlides, { interval: 5000, dots: true, autoplay: true });

    document.querySelectorAll<HTMLElement>('.slide-banner-wrap').forEach((el) => {
      el.style.display = 'block';
    });
  }

  // Collage tiles behave as links without being anchors.
  document.querySelectorAll<HTMLElement>('.collage.grid div[data-action=navigate]').forEach((tile) => {
    tile.addEventListener('click', () => {
      const target = tile.dataset.target;

      if (target) {
        window.location.assign(target);
      }
    });
  });
}

const PAGE_INITIALISERS: Record<string, () => void> = {
  home: initHome,
};

export function initPages(): void {
  document.querySelectorAll<HTMLElement>('main[data-init]').forEach((main) => {
    const name = main.dataset.init;

    // The 2.2 switch was missing a break after its only case, so adding a second
    // page would have silently run the wrong initialiser. A lookup cannot.
    if (name && name in PAGE_INITIALISERS) {
      PAGE_INITIALISERS[name]();
    }
  });
}
